import React from "react";
import {
  useQuery,
  UseQueryResult,
  UseQueryOptions,
} from "@tanstack/react-query";

import { AuthContext } from "@contexts/auth/AuthContextProvider";
import { IAuthContext } from "@type";

export type UseGetIdentityProps<TData> = {
  queryOptions?: UseQueryOptions<TData>;
};

export const useGetIdentity = <TData = any>({
  queryOptions,
}: UseGetIdentityProps<TData> = {}): UseQueryResult<TData, unknown> => {
  const { getUserIdentity } = React.useContext<IAuthContext>(AuthContext);

  const queryResponse = useQuery<TData>({
    queryKey: ["getUserIdentity"],
    // Enabled check for `getUserIdentity` is enough to be sure that it's defined in the query function but TS is not smart enough to know that.
    queryFn: getUserIdentity ?? (() => Promise.resolve({})),
    enabled: !!getUserIdentity,
    retry: false,
    ...queryOptions,
  });

  return queryResponse;
};
